import {
    http, HttpResponse, bypass, passthrough
} from 'msw';

type MetricsParams = never;
type MetricsRequestBody = never;
type MetricsResponseBody = Record<string, unknown>;
// Wildcard at start to match http for local dev environment
const workstreamMetricsTpmPath = '*/performance-metrics/tpm/workstream';
const interactionMetricsTpmPath = '*/performance-metrics/tpm/interaction';

export const handlers = [
    http.get<MetricsParams, MetricsRequestBody, MetricsResponseBody>(
        workstreamMetricsTpmPath,
        async ({ request }) => {
            try {
                // Make a call to interactions, we will update that response to mock workstreams
                const { headers, url } = request;
                if (url.includes('interval')) {
                    return passthrough();
                }
                const bypassUrl = new URL(url);
                bypassUrl.searchParams.set('interval', 'day');

                // Construct a proxy request based on the intercepted request
                // but provide a new URL that contains modified query parameters.
                const proxyRequest = new Request(bypassUrl, request);
                const metricsResponse = await fetch(bypass(proxyRequest), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        // Include any necessary headers from the initial request
                        ...Object.fromEntries(headers)
                    }
                });
                const metrics = await metricsResponse.json();

                // The JSON response body type must satisfy
                // the "AddCommentResponseBody" type.
                return HttpResponse.json({ ...metrics });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('MSW Error', e);
                return HttpResponse.json({ error: 'An error occurred' }, { status: 500 });
            }
        }
    ),
    http.get<MetricsParams, MetricsRequestBody, MetricsResponseBody>(
        interactionMetricsTpmPath,
        async ({ request }) => {
            try {
                // Make a call to interactions, we will update that response to mock workstreams
                const { headers, url } = request;
                if (url.includes('interval')) {
                    return passthrough();
                }
                const bypassUrl = new URL(url);
                bypassUrl.searchParams.set('interval', 'day');

                // Construct a proxy request based on the intercepted request
                // but provide a new URL that contains modified query parameters.
                const proxyRequest = new Request(bypassUrl, request);
                const metricsResponse = await fetch(bypass(proxyRequest), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        // Include any necessary headers from the initial request
                        ...Object.fromEntries(headers)
                    }
                });
                const metrics = await metricsResponse.json();

                // The JSON response body type must satisfy
                // the "AddCommentResponseBody" type.
                return HttpResponse.json({ ...metrics });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('MSW Error', e);
                return HttpResponse.json({ error: 'An error occurred' }, { status: 500 });
            }
        }
    )
];
